exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-table-filters[data-v-2272eace]{display:flex;flex-wrap:wrap;margin:.75rem -.25rem}.vtf-button[data-v-2272eace]{font-size:12px;line-height:1;padding:.25rem .75rem;border:1px solid #ddd;border-radius:50rem;margin:.25rem;cursor:pointer;transition:.2s ease-out}.vtf-button[data-v-2272eace]:hover{background-color:#ddd}.vtf-button.active[data-v-2272eace]{background-color:#222;border:1px solid #111;color:#fff}.vtf-button.active[data-v-2272eace]:hover{background-color:#111}", ""]);

// exports
